import React from 'react';
import ActionConfirmModal from './ActionConfirmModal';

export default function ConfirmLeaveModal({ open, onConfirm, onCancel }) {
  return (
    <ActionConfirmModal
      open={open}
      title="Unsaved Changes"
      message="You have unsaved changes. If you leave now, your edits will be lost."
      confirmLabel="Discard and Leave"
      cancelLabel="Stay on Page"
      onConfirm={onConfirm}
      onCancel={onCancel}
      danger
    />
  );
}
